import React, { useEffect, useState } from 'react';
import { GiChefToque, GiCrown, GiForkKnifeSpoon } from 'react-icons/gi';
import { Navbar, FooterOverlay, SubHeading } from '../../components';
import { StyleSheet, css } from 'aphrodite';

const AboutUs = () => {
  // Trigger animations after component mounts
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    setTimeout(() => setAnimate(true), 150);
  }, []);

  return (
    <>
      {/* Navbar */}
      <Navbar />

      {/* Main About section */}
      <div className={css(styles.aboutSection)}>
        {/* Animated SubHeading wrapper */}
        <div className={css(animate && styles.fadeRight)}>
          <SubHeading title="About Us" />
        </div>

        {/* About content blocks */}
        <div className={css(styles.aboutContent)}>
          {/* Welcome Block */}
          <div className={css(styles.aboutBlock, animate && styles.fadeLeft)}>
            <GiForkKnifeSpoon className={css(styles.icon)} />
            <p className={css(styles.text)}>
              Welcome to Fortress Restaurant, where the rich heritage of African
              Mediterranean cuisine meets elegance and culinary mastery to
              create unforgettable dining experiences. At Fortress, we pride
              ourselves on offering a perfect fusion of bold African flavors and
              Mediterranean sophistication, combined with refined service and a
              stylish atmosphere, ensuring every visit is truly remarkable.
            </p>
          </div>

          {/* Mission Block */}
          <div className={css(styles.aboutBlock, animate && styles.fadeRight)}>
            <GiChefToque className={css(styles.icon)} />
            <p className={css(styles.text)}>
              Our mission is to provide guests with an unparalleled dining
              experience—merging the finest ingredients with impeccable
              preparation and a deep attention to detail. From the moment you
              step into our doors, we aim to captivate your senses with flavors
              that blend the best of Africa and the Mediterranean, presented
              with warmth and artistry in every dish.
            </p>
          </div>

          {/* Vision Block */}
          <div className={css(styles.aboutBlock, animate && styles.fadeLeft)}>
            <GiCrown className={css(styles.icon)} />
            <p className={css(styles.text)}>
              Our vision is to establish Fortress as the premier destination for
              luxury African Mediterranean dining, renowned not only in Pretoria
              but far beyond. We are committed to innovation, quality, and
              excellence in every aspect of hospitality, ensuring that each
              visit leaves a lasting impression. Whether celebrating a special
              occasion or simply enjoying an evening out, every moment at
              Fortress promises to be extraordinary.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <FooterOverlay />
    </>
  );
};

export default AboutUs;

// ---------------------------- STYLES ----------------------------
const styles = StyleSheet.create({
  // Main About section container
  aboutSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10rem 2rem 6rem',
    background: 'var(--color-cream)',
  },

  // Container for all content blocks
  aboutContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    maxWidth: '1000px',
    width: '100%',
    marginTop: '2rem',
  },

  // Individual block: icon + paragraph
  aboutBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: 'clamp(2rem,5vw,4rem)',
    background: 'var(--color-paper)',
    border: '1px solid rgba(35,79,64,.11)',
    borderRadius: '18px',
    boxShadow: '0 18px 60px rgba(23,60,50,.07)',
  },

  // Icon styling
  icon: {
    fontSize: '50px',
    color: 'var(--color-green)',
    marginBottom: '1rem',
  },

  // Paragraph text
  text: {
    fontFamily: 'var(--font-alt)',
    fontSize: '16px',
    lineHeight: '1.8',
    color: 'var(--color-gray)',
    '@media (max-width: 650px)': {
      fontSize: '14px',
      lineHeight: '1.6',
    },
    '@media (max-width: 450px)': {
      fontSize: '13px',
      lineHeight: '1.5',
    },
  },

  /* ================= Animations ================= */
  fadeLeft: {
    animationName: {
      from: { opacity: 0, transform: 'translateX(-60px)' },
      to: { opacity: 1, transform: 'translateX(0)' },
    },
    animationDuration: '0.9s',
  },

  fadeRight: {
    animationName: {
      from: { opacity: 0, transform: 'translateX(60px)' },
      to: { opacity: 1, transform: 'translateX(0)' },
    },
    animationDuration: '0.9s',
  },
});
